<template>
  <!-- Begin: Services -->
  <div class="col-xl" id="servicesPortlet" data-section="Dashboard">
    <!--begin::Portlet-->
    <div class="m-portlet m-portlet--rounded m-portlet--head-sm">
      <div class="m-portlet__head">
        <div class="m-portlet__head-caption">
          <div class="m-portlet__head-title">
            <h3 class="m-portlet__head-text">
              {{ $t("Dashboard.services") }}
            </h3>
          </div>
        </div>
      </div>
      <div class="m-portlet__body">
        <!--begin::m-widget5-->
        <div class="m-widget5">
          <div class="m-widget5__item pt-1 pb-0">
            <div class="m-widget5__content">
              <div class="m-widget5__section">
                <h4 class="m-widget5__title">
                  <span v-if="premiumFeaturedProperties > 0">{{
                    premiumFeaturedProperties
                  }}</span>
                  {{ this.$t("services.PremiumFeaturedPropertyListing") }}
                </h4>
              </div>
            </div>

            <div class="m-widget5__content">
              <div class="m-widget5__section">
                <div class="pt-0 m-widget5__stats1">
                  <div>
                    <template v-if="premiumFeaturedProperties > 0">
                      <span v-if="propertyService.Status == 'ACTIVE_SUSPENDED'">
                        <span class="font-weight-bold m--font-danger">{{
                          this.$t("homepage.services.onhold")
                        }}</span>
                      </span>
                      <span v-if="propertyService.Status == 'ACTIVE_PENDING'">
                        <span class="font-weight-bold m--font-danger">{{
                          this.$t("homepage.services.pendingactivation")
                        }}</span>
                      </span>
                      <span v-if="propertyService.Status == 'ACTIVE_EXPIRED'">
                        <span class="font-weight-bold m--font-orange">{{
                          this.$t("homepage.services.activeexpiredWithDate", { date: endDate })
                        }}</span>
                      </span>
                      <span v-if="propertyService.Status == 'ACTIVE'">
                        <span class="font-weight-bold m--font-success">{{
                          this.$t("homepage.services.active")
                        }}</span>
                      </span>
                      <span v-if="propertyService.Status == 'NOT_ACTIVE'">
                        <span class="font-weight-bold m--font-danger">{{
                          this.$t("homepage.services.notactive")
                        }}</span>
                      </span>
                      <span v-if="propertyService.Status == 'NO_RESULTS'">
                        <span class="font-weight-bold m--font-danger">{{
                          this.$t("homepage.services.notcontracted")
                        }}</span>
                      </span>
                    </template>
                    <template v-else>
                      <span class="font-weight-bold m--font-danger">{{
                      this.$t("homepage.services.notcontracted")
                      }}</span>
                    </template>
                  </div>
                  <br />
                </div>
              </div>
            </div>
          </div>

          <div class="m-widget5__item pt-1 pb-0">
            <div class="m-widget5__content">
              <div class="m-widget5__section">
                <h4 class="m-widget5__title">
                  <span v-if="featuredProperties > 0">{{
                    featuredProperties
                  }}</span>
                  {{ this.$t("services.FeaturedPropertyListing") }}
                </h4>
              </div>
            </div>

            <div class="m-widget5__content">
              <div class="m-widget5__section">
                <div class="pt-0 m-widget5__stats1">
                  <div>
                    <template v-if="featuredProperties > 0">
                      <span v-if="propertyService.Status == 'ACTIVE_SUSPENDED'">
                        <span class="font-weight-bold m--font-danger">{{
                          this.$t("homepage.services.onhold")
                        }}</span>
                      </span>
                      <span v-if="propertyService.Status == 'ACTIVE_PENDING'">
                        <span class="font-weight-bold m--font-danger">{{
                          this.$t("homepage.services.pendingactivation")
                        }}</span>
                      </span>
                      <span v-if="propertyService.Status == 'ACTIVE_EXPIRED'">
                        <span class="font-weight-bold m--font-orange">{{
                          this.$t("homepage.services.activeexpiredWithDate", { date: endDate })
                        }}</span>
                      </span>
                      <span v-if="propertyService.Status == 'ACTIVE'">
                        <span class="font-weight-bold m--font-success">{{
                          this.$t("homepage.services.active")
                        }}</span>
                      </span>
                      <span v-if="propertyService.Status == 'NOT_ACTIVE'">
                        <span class="font-weight-bold m--font-danger">{{
                          this.$t("homepage.services.notactive")
                        }}</span>
                      </span>
                      <span v-if="propertyService.Status == 'NO_RESULTS'">
                        <span class="font-weight-bold m--font-danger">{{
                          this.$t("homepage.services.notcontracted")
                        }}</span>
                      </span>
                    </template>
                    <template v-else>
                      <span class="font-weight-bold m--font-danger">{{
                      this.$t("homepage.services.notcontracted")
                      }}</span>
                    </template>
                  </div>
                  <br />
                </div>
              </div>
            </div>
          </div>

          <div class="m-widget5__item pt-1 pb-0">
            <div class="m-widget5__content">
              <div class="m-widget5__section">
                <h4 class="m-widget5__title">
                  <span v-if="properties > 0">{{ properties }}</span>
                  {{ this.$t("services.PropertyService") }}
                  <span class="small">
                    <span
                      v-if="
                        propertyService.ImportType === 'Manual' &&
                        propertyService.ManualSelection === false
                      "
                    >
                      {{ this.$t("services.ManualUpload") }}
                    </span>
                    <span
                      v-if="
                        propertyService.ImportType === 'XML' &&
                        propertyService.ManualSelection === true
                      "
                    >
                      {{ this.$t("services.XMLImportManualSelection") }}
                    </span>
                    <span
                      v-if="
                        propertyService.ImportType === 'XML' &&
                        propertyService.ManualSelection === false
                      "
                    >
                      {{ this.$t("services.XMLImport") }}
                    </span>
                  </span>
                </h4>
              </div>
            </div>

            <div class="m-widget5__content">
              <div class="m-widget5__section">
                <div class="pt-0 m-widget5__stats1">
                  <div>
                    <span v-if="propertyService.Status == 'ACTIVE_SUSPENDED'">
                      <span class="font-weight-bold m--font-danger">{{
                        this.$t("homepage.services.onhold")
                      }}</span>
                    </span>
                    <span v-if="propertyService.Status == 'ACTIVE_PENDING'">
                      <span class="font-weight-bold m--font-danger">{{
                        this.$t("homepage.services.pendingactivation")
                      }}</span>
                    </span>
                    <span v-if="propertyService.Status == 'ACTIVE_EXPIRED'">
                      <span class="font-weight-bold m--font-orange">{{
                        this.$t("homepage.services.activeexpiredWithDate", { date: endDate })
                      }}</span>
                    </span>
                    <span v-if="propertyService.Status == 'ACTIVE'">
                      <span class="font-weight-bold m--font-success">{{
                        this.$t("homepage.services.active")
                      }}</span>
                    </span>
                    <span v-if="propertyService.Status == 'NOT_ACTIVE'">
                      <span class="font-weight-bold m--font-danger">{{
                        this.$t("homepage.services.notactive")
                      }}</span>
                    </span>
                    <span v-if="propertyService.Status == 'NO_RESULTS'">
                      <span class="font-weight-bold m--font-danger">{{
                        this.$t("homepage.services.notcontracted")
                      }}</span>
                    </span>
                  </div>
                  <br />
                </div>
              </div>
            </div>
          </div>

          <div class="m-widget5__item pt-1 pb-0">
            <div class="m-widget5__content">
              <div class="m-widget5__section">
                <h4 class="m-widget5__title">
                  <span v-if="premiumFeaturedDirectories > 0">
                    {{ premiumFeaturedDirectories }}
                  </span>
                  {{ this.$t("services.PremiumFeaturedDirectoryListing") }}
                </h4>
              </div>
            </div>

            <div class="m-widget5__content">
              <div class="m-widget5__section">
                <div class="pt-0 m-widget5__stats1">
                  <div>
                    <span
                      class="font-weight-bold m--font-success"
                      v-if="premiumFeaturedDirectories > 0"
                      >{{ this.$t("homepage.services.active") }}</span
                    >
                    <span class="font-weight-bold m--font-danger" v-else>{{
                      this.$t("homepage.services.notcontracted")
                    }}</span>
                  </div>
                  <br />
                </div>
              </div>
            </div>
          </div>

          <div class="m-widget5__item pt-1 pb-0">
            <div class="m-widget5__content">
              <div class="m-widget5__section">
                <h4 class="m-widget5__title">
                  <span v-if="featuredDirectories > 0">
                    {{ featuredDirectories }}
                  </span>
                  {{ this.$t("services.DirectoryFeaturedListing") }}
                </h4>
              </div>
            </div>

            <div class="m-widget5__content">
              <div class="m-widget5__section">
                <div class="pt-0 m-widget5__stats1">
                  <div>
                    <span
                      class="font-weight-bold m--font-success"
                      v-if="featuredDirectories > 0"
                      >{{ this.$t("homepage.services.active") }}</span
                    >
                    <span class="font-weight-bold m--font-danger" v-else>{{
                      this.$t("homepage.services.notcontracted")
                    }}</span>
                  </div>
                  <br />
                </div>
              </div>
            </div>
          </div>

          <div class="m-widget5__item pt-1 pb-0 mb-0">
            <div class="m-widget5__content">
              <div class="m-widget5__section">
                <h4 class="m-widget5__title">
                  <span v-if="directories > 0">
                    {{ directories }}
                  </span>
                  <span v-html="$t('services.FreeDirectory')"></span>
                </h4>
              </div>
            </div>

            <div class="m-widget5__content">
              <div class="m-widget5__section">
                <div class="pt-0 m-widget5__stats1">
                  <div>
                    <span
                      class="font-weight-bold m--font-success"
                      v-if="directories > 0"
                      >{{ this.$t("homepage.services.active") }}</span
                    >
                    <span class="font-weight-bold m--font-danger" v-else>{{
                      this.$t("homepage.services.notactive")
                    }}</span>
                  </div>
                  <br />
                </div>
              </div>
            </div>
          </div>
        </div>

        <!--end::m-widget5-->
      </div>

      <!--end::Form-->
    </div>
    <!--end::Portlet-->
  </div>
  <!-- End: Services -->
</template>


<script>
import functions from "@/plugins/functions";
import dayjs from 'dayjs'

export default {
  name: "Services",
  data() {
    return {
      user: {},
      propertyService: {},
      featuredService: {},
      directoryService: {}
    };
  },
  async mounted() {
    mApp.block('#servicesPortlet', {message: this.$t('common.LoadingDataPleaseWait')})
    this.user = functions.getUser();
    let propertyCall = functions.getPropertyService()
    let featuredCall = functions.getFeaturedService()
    let directoryCall = functions.getDirectoryService()
    this.propertyService = await propertyCall
    this.featuredService = await featuredCall
    this.directoryService = await directoryCall
    mApp.unblock('#servicesPortlet')
  },
  computed: {
    premiumFeaturedProperties() {
      return this.featuredService.MaxFeaturedPremium;
    },
    featuredProperties() {
      return this.featuredService.MaxFeaturedStandard;
    },
    properties() {
      return this.propertyService.PropertyLimit;
    },
    premiumFeaturedDirectories() {
      return this.directoryService.FeaturedPremium;
    },
    featuredDirectories() {
      return this.directoryService.Featured;
    },
    directories() {
      return this.directoryService.Free;
    },
    endDate(){
      if (!this.propertyService.EndDate) {
        return ''
      }
      return dayjs(this.propertyService.EndDate).tz().format("DD/MM/YYYY")
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/dashboard/stats/Services.vue